module.exports = __webpack_public_path__ + "static/media/29FUNOV5.3c173d52.jpg";